import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// components
import { Button } from "../../_commons/Button";
import CreateIcon from "../../_commons/CreateIcon";

// utils
import { lS } from "../../../atlas-utils";
import { getEncodedAnalyticsFilters } from "../../../actions/analytics";

const CustomersBanner = ({ login }) => {
	const history = useHistory();
	const bizId = login?.loggedInbizDetail?.id;
	let lsAnalytics = lS.get("analytics") || {};
	const [imgBannerDismissed, setImgBannerDismissed] = useState(lsAnalytics?.customers?.[bizId]?.imgBanner);

	const dismissBanner = () => {
		if (!lsAnalytics.customers) {
			lsAnalytics.customers = {};
		}
		if (!lsAnalytics.customers[bizId]) {
			lsAnalytics.customers[bizId] = {};
		}
		lsAnalytics.customers[bizId] = { ...lsAnalytics.customers[bizId], imgBanner: true };
		setImgBannerDismissed(true);
		lS.set("analytics", lsAnalytics);
	};

	const goToPage = () => {
		history.push(`/analytics/customers?filters=${getEncodedAnalyticsFilters()}`);
		dismissBanner();
	};

	if (imgBannerDismissed) return null;

	return (
		<>
			<div className="customer-img-banner">
				<img src="/assets/analytics/compare/stars_bg.svg" className="star-img" />
				<img src="/assets/analytics/compare/ellipse_left.svg" className="ellipse_left" />
				<img src="/assets/analytics/compare/ellipse_right.svg" className="ellipse_right" />
				<div className="head-text">
					<div className="main-text">
						Want to know who your <span className="blue-text">New</span> and{" "}
						<span className="blue-text">Repeat Customers</span> are?
					</div>
					<div className="desc">
						Check out all new
						<span className="highlight">Customer Analytics</span>
					</div>
					<Button onClick={goToPage}>
						Explore
						<img className="arrow-right" src="/assets/analytics/right-arrow-white.svg" />
					</Button>
				</div>
				<div className="img-banner">
					<img src="/assets/analytics/customer-analytics-banner.svg" />
				</div>

				<div className="main-close-icon" onClick={dismissBanner}>
					<CreateIcon color={"#363636"} />
				</div>
			</div>
		</>
	);
};

export default connect((store) => ({
	login: store.login
}))(CustomersBanner);
